import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  Spinner,
} from "@fluentui/react-components";
import { useSessionExpiredDialogI18n } from "./SessionExpiredDialog.i18n";
import { useSessionExpiredDialogViewModel } from "./SessionExpiredDialog.ViewModel";

/**
 * Asks the user to sign in again over the page they are on, so nothing on it
 * is lost. Deliberately has no way to dismiss it: the calls behind it are
 * waiting for the new session.
 */
const SessionExpiredDialog: React.FC = () => {
  const { isOpen, isSigningIn, popupBlocked, hasFailed, handleSignIn } =
    useSessionExpiredDialogViewModel();
  const i18n = useSessionExpiredDialogI18n();

  return (
    <Dialog open={isOpen} modalType="alert">
      <DialogSurface>
        <DialogBody>
          <DialogTitle>{i18n.title}</DialogTitle>
          <DialogContent>
            {popupBlocked
              ? i18n.blockedLead
              : hasFailed
                ? i18n.failedLead
                : i18n.lead}
          </DialogContent>
          <DialogActions>
            <Button
              appearance="primary"
              disabled={isSigningIn}
              onClick={handleSignIn}
              icon={isSigningIn ? <Spinner size="tiny" /> : undefined}
            >
              {isSigningIn
                ? i18n.signingIn
                : popupBlocked || hasFailed
                  ? i18n.tryAgain
                  : i18n.signIn}
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};

export default SessionExpiredDialog;
